var React = require('react');

function ArrowDownOrange (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15 0.0945845V3.2439L7.50166 6.9054L9.53674e-07 3.2439V0.0945845L7.50166 3.75608L15 0.0945845Z","fill":"#F18841"}));
}

ArrowDownOrange.defaultProps = {"width":"15","height":"7","viewBox":"0 0 15 7","fill":"none"};

module.exports = ArrowDownOrange;

ArrowDownOrange.default = ArrowDownOrange;
